import { put } from 'redux-saga/effects';
import { sendError, userReset } from '../../../';
import { logoutError, LogoutFetch } from '../actions';
export function* logoutSaga(action: LogoutFetch) {
    try {
        yield put(userReset());
        localStorage.removeItem('csrfToken');
        localStorage.removeItem('themeCode');
        // yield put(userOpenOrdersReset());
        // yield put(resetHistory());
    } catch (error: any) {
        const errorSetup = {
            message: error.response.data.errors[0].errorMessage,
            code: error.response.status,
            codeConfig: error.response.data.errors[0].errorCode,
        };
        yield put(
            sendError({
                error: errorSetup,
                processingType: 'alert',
                extraOptions: {
                    actionError: logoutError,
                },
            }),
        );
    }
}
